import { objectToEnumMap } from './enum-helper';
import colorParser from './color';

/**
 * Типы бэкграундов
 * @type {Object}
 */
export var BACKGROUND_TYPE = {
    solid: 'div-solid-background',
    gradient: 'div-gradient-background',
    image: 'div-image-background'
};

export var AVAILABLE_BACKGROUND_TYPE = objectToEnumMap(BACKGROUND_TYPE);

export default (function (backgrounds) {
    if (!Array.isArray(backgrounds)) {
        return [];
    }

    return backgrounds.map(function (background) {
        var type = background.type;


        switch (type) {
            case BACKGROUND_TYPE.solid:
                return {
                    type: type,
                    color: colorParser(background.color)
                };
            case BACKGROUND_TYPE.gradient:
                return {
                    type: type,
                    startColor: colorParser(background.start_color),
                    endColor: colorParser(background.end_color)
                };
            case BACKGROUND_TYPE.image:
                return {
                    type: type,
                    imageUrl: background.image_url
                };
            default:
                return null;
        }
    }).filter(Boolean);
});